import { render, staticRenderFns } from "./device_page.vue?vue&type=template&id=73d25fad&scoped=true"
import script from "./device_page.vue?vue&type=script&lang=js"
export * from "./device_page.vue?vue&type=script&lang=js"
import style0 from "./device_page.vue?vue&type=style&index=0&id=73d25fad&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d25fad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73d25fad')) {
      api.createRecord('73d25fad', component.options)
    } else {
      api.reload('73d25fad', component.options)
    }
    module.hot.accept("./device_page.vue?vue&type=template&id=73d25fad&scoped=true", function () {
      api.rerender('73d25fad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/device_page.vue"
export default component.exports